module.exports = __webpack_public_path__ + "static/media/newhome.c585fb77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DreamGarage/newhome.jpg
// module id = 1159
// module chunks = 0